import { object, string } from '@gogame/schemas';

import { scopeSchema as groupsScopeSchema } from '../ConversionGroups/schemas';
import { scopeSchema as pagesScopeSchema } from '../ConversionPages/schemas';
import {
  SCOPE_GROUPS,
  SCOPE_PAGES,
} from 'scenes/Gallery/ConversionPages/constants';

import { filtersSchema } from './filtersSchema';

export const presetSchema = object({
  filters: filtersSchema,
  searchQuery: string(),
  [SCOPE_GROUPS]: groupsScopeSchema,
  [SCOPE_PAGES]: pagesScopeSchema,
});

export const mapStateToPreset = (screenState) => {
  return presetSchema.stripDefaults().cast(screenState, {
    applyConst: true,
    stripUnknown: true,
  });
};
